(function () {
    if (typeof document == 'undefined') return;
    tinymce.PluginManager.add('image_upload', function(editor) {

        // tinymce.activeEditor.windowManager._open = editor.windowManager.open;
        // tinymce.activeEditor.windowManager.open = function() {
        //     if (arguments.length === 0 || arguments[0].title !== 'Insert/Edit Image') {
        //         return this._open.apply(this, arguments);
        //     }
        //     var id = 'body-' + new Date().getTime();
        //     arguments[0].body.classes = [id];
        //     var modal = this._open.apply(this, arguments);
        //     var button = document.querySelector('.' + id + ' .tox-form__controls-h-stack button.tox-browse-url');
        //     if (button !== undefined && button !== null) {
        //         var fileInput = document.createElement('input');
        //         fileInput.setAttribute('type', 'file');
        //         fileInput.setAttribute('title', '');
        //         fileInput.setAttribute('accept', 'image/*');
        //         fileInput.style.opacity = 0;
        //         fileInput.style.position = 'absolute';
        //         fileInput.style.right = '0px';
        //         fileInput.style.bottom = '0px';
        //         fileInput.style.width = '50px';
        //         fileInput.style.height = '50px';
        //         fileInput.style.cursor = 'pointer';
        //         fileInput.onchange = function(e) {
        //             if (this.type === 'file' && this.files && this.files.length > 0) {
        //                 var fileInfo = this.files[0];
        //                 if (/^image\//.test(fileInfo.type)) {
        //                     //TODO
        //                 }
        //             }
        //             this.value = '';
        //         };
        //         button.appendChild(fileInput);
        //     }
        //     return modal;
        // }.bind(tinymce.activeEditor.windowManager);

        editor.options.register('image_upload_cache', {
            processor: 'boolean',
            default: true
        });
        var imageUploadCache = editor.options.get('image_upload_cache');

        editor.options.set('file_picker_types', 'image');
        editor.options.set('file_picker_callback', function (callback, value, meta) {
            var input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.onchange = function () {
                var file = this.files[0];
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    if (imageUploadCache === true) {
                        var id = 'blobid' + new Date().getTime();
                        var blobCache = tinymce.activeEditor.editorUpload.blobCache;
                        var base64 = fileReader.result.split(',')[1];
                        var blobInfo = blobCache.create(id, file, base64);
                        blobCache.add(blobInfo);
                        callback(blobInfo.blobUri(), { title: file.name });
                    } else {
                        var dataUrl = e.target.result;
                        callback(dataUrl, { title: file.name });
                    }
                };
                fileReader.readAsDataURL(file);
            };
            input.click();
        });
        return false;
    });
})();
